import React from "react"

function Services() {
  return (
    <div className="row">
      {/* Single Service Item */}
      <div className="col-md-3 col-sm-6 col-xs-12  no-padding">
        <div className="service-block">
          <div className="service-icon text-center">
            <i className="tf-ion-ios-compose-outline"></i>
            <h3>Identity</h3>
          </div>
          <p>&#9656; Brand Development</p>
          <p>&#9656; Market Research</p>
          <p>&#9656; Marketing Strategy</p>
        </div>
      </div>
      {/* End Single Service Item */}
      {/* Single Service Item */}
      <div className="col-md-3 col-sm-6 col-xs-12  no-padding">
        <div className="service-block color-bg">
          <div className="service-icon text-center">
            <i className="tf-ion-ios-analytics-outline"></i>
            <h3>Product</h3>
          </div>
          <p>&#9656; Feasibilty Analysis</p>
          <p>&#9656; Product Entry Strategy</p>
          <p>&#9656; Risk Management</p>
          <br />
        </div>
      </div>
      {/* End Single Service Item */}
      {/* Single Service Item */}
      <div className="col-md-3 col-sm-6 col-xs-12  no-padding">
        <div className="service-block">
          <div className="service-icon text-center">
            <i className="tf-ion-android-arrow-up"></i>
            <h3>Profitability</h3>
          </div>
          <p>&#9656; Cost Minimization</p>
          <p>&#9656; Financial Analysis</p>
          <p>&#9656; Pricing Strategy</p>
        </div>
      </div>
      {/* End Single Service Item */}
      {/* Single Service Item */}
      <div className="col-md-3 col-sm-6 col-xs-12  no-padding">
        <div className="service-block color-bg">
          <div className="service-icon text-center">
            <i className="tf-ion-ios-bolt-outline"></i>
            <h3>Impact</h3>
          </div>
          <p>&#9656; Economic Resilience</p>
          <p>&#9656; Fundraising Strategy</p>
          <p>&#9656; Resource Discovery</p>
          <br />
        </div>
      </div>
      {/* End Single Service Item */}
    </div>
  )
}

export default Services
